<div>
  <p class="auth-desc auth-register-desc">
    {{ 'pages.register.step3.description' | i18n }}
  </p>
  
  <form [formGroup]="step3Form" class="auth-form" (ngSubmit)="submitRegistration()">
    
    <div class="input-group">
      <umkt-custom-input 
        formControlName="nomeCompleto" 
        id="nomeCompleto" 
        [ariaLabel]="'pages.register.step3.fullName.label' | i18n"
        [placeholder]="'pages.register.step3.fullName.placeholder' | i18n" 
        [maxlength]="255"
        (keydown)="preventLeadingSpace($event)">
      </umkt-custom-input>
      
      <div *ngIf="step3Form.get('nomeCompleto')?.errors?.['invalidFullName'] && step3Form.get('nomeCompleto')?.touched"
        class="field-error">
        {{ 'pages.register.step3.fullName.errorInvalid' | i18n }}
      </div>
    </div>
    <div class="input-group">
      <umkt-custom-input 
        formControlName="email" 
        id="email" 
        type="email" 
        [ariaLabel]="'pages.register.step3.email.label' | i18n" 
        [placeholder]="'pages.register.step3.email.placeholder' | i18n"
        [maxlength]="255">
      </umkt-custom-input>
      
      <div *ngIf="(step3Form.get('email')?.hasError('email') || step3Form.get('email')?.hasError('invalidEmailDomain')) 
        && step3Form.get('email')?.touched" class="field-error">
        {{ 'pages.register.step3.email.errorInvalid' | i18n }}
      </div>
    </div>
    <div class="input-group">
      <umkt-custom-input 
        #passwordInput 
        formControlName="password" 
        id="password" 
        type="password" 
        [ariaLabel]="'pages.register.step3.password.label' | i18n"
        [placeholder]="'pages.register.step3.password.placeholder' | i18n" 
        (passwordToggle)="onPasswordToggle($event)"
        maxLength="256">
      </umkt-custom-input>
      
      <div *ngIf="step3Form.get('password')?.errors?.['invalidPassword'] && step3Form.get('password')?.touched" class="field-error">
        {{ 'pages.register.step3.password.errorInvalid' | i18n }}
      </div>
    </div>
    <div class="input-group">
      <umkt-custom-input 
        #confirmPasswordInput 
        formControlName="confirmPassword" 
        id="confirmPassword" 
        type="password"
        [ariaLabel]="'pages.register.step3.confirmPassword.label' | i18n" 
        [placeholder]="'pages.register.step3.confirmPassword.placeholder' | i18n" 
        (passwordToggle)="onPasswordToggle($event)"
        maxLength="256">
      </umkt-custom-input>
      
      <div *ngIf="step3Form.get('confirmPassword')?.errors?.['mismatch'] && step3Form.get('confirmPassword')?.touched"
        class="field-error">
        {{ 'pages.register.step3.confirmPassword.errorMismatch' | i18n }}
      </div>
    </div>
    <umkt-password-requirements [requirements]="passwordRequirements"
      [isPristine]="!step3Form.get('password')?.value"></umkt-password-requirements>
    <ustore-button type="submit" [text]="'pages.register.step3.submitButton' | i18n" [disabled]="step3Form.invalid || loading" [full]="true"
      [backgroundColor]="'var(--color-red-500-to-yellow)'" [textColor]="'var(--color-inverted)'" [format]="'filled'" [size]="'medium'"
      [rounded]="'default'"
      [icon]="{ name: 'arrow_forward', type: 'material-icons', position: 'right' }">
    </ustore-button>
    
    <div class="auth-register">
      {{ 'shared.auth.hasAccount' | i18n }} <a (click)="goToLogin()">{{ 'shared.buttons.login' | i18n }}</a>
    </div>
  </form>
</div>